import * as React from "react";
import { forwardRef } from "react";
const SvgSelectedRadioBtn = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 10, cy: 10, r: 7.25, fill: "white", stroke: "#17457D", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("circle", { cx: 10, cy: 10, r: 3, fill: "#17457D" }));
const ForwardRef = forwardRef(SvgSelectedRadioBtn);
export default ForwardRef;
